import { FormValues } from "./Anthropometry";

const REQUIRED = "Поле обязательно для заполнения";

export const required = (value: string) => {
  if (!value) {
    return REQUIRED;
  }

  return undefined;
};

export const formValidator = (values: FormValues) => {
  let errors: { [key in keyof FormValues]?: string } = {};

  const numberFields = ["custom_масса_тела", "custom_рост"] as const;

  numberFields.forEach((key) => {
    const value = values[key] as string;

    if (!value) {
      return;
    }

    const isValid = /^\d{1,3}([,]\d{1,2})?$/.test(value);

    if (!isValid) {
      errors[key] = "Некорректное значение";
    }
  });

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};
